import {Decoder, oneOf, equal} from 'json-bouncer'

export type InquiryProofCopyStatus =
    | 'requested'
    | 'inApproval'
    | 'approved'
    | 'rejected'
    | 'notRequired'

export function proofCopyStatusDecoder(): Decoder<InquiryProofCopyStatus> {
    const requested: InquiryProofCopyStatus = 'requested'
    const inApproval: InquiryProofCopyStatus = 'inApproval'
    const approved: InquiryProofCopyStatus = 'approved'
    const rejected: InquiryProofCopyStatus = 'rejected'
    const notRequired: InquiryProofCopyStatus = 'notRequired'
    return oneOf([
        equal(requested),
        equal(inApproval),
        equal(approved),
        equal(rejected),
        equal(notRequired)
    ])
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryProofCopyStatus.ts